import { render, staticRenderFns } from "./TheMainMenu.vue?vue&type=template&id=3ef354db&scoped=true"
import script from "./TheMainMenu.vue?vue&type=script&lang=js"
export * from "./TheMainMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMainMenu.vue?vue&type=style&index=0&id=3ef354db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef354db",
  null
  
)

export default component.exports